import { useApiAccountsQuery } from "@sso/apis/apiAccounts";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectAPIAccountQuery } from "@sso/store/slices/apiAccount";

export const useGetApiAccountsQuery = () => {
  const queryParams = useAppSelector(selectAPIAccountQuery);
  return useApiAccountsQuery(queryParams);
};
